import { API_AUTH } from "../common";

const CongNoBanHangApi = {
  getData: ({
    SearchText,
    DateFrom,
    DateTo,
    pageIndex,
    pageSize
  }) =>
    API_AUTH.get(
      `QuanLyMuaBan/CongNoBanHang/GetDanhSach?SearchText=${SearchText}&DateFrom=${DateFrom}&DateTo=${DateTo}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {}
    ),

  getThongTinThanhToan: (orderId) => 
    API_AUTH.get(`QuanLyMuaBan/CongNoBanHang/GetThongTinThanhToan?orderId=${orderId}`),

  luuThanhToan: (data) => 
    API_AUTH.post(`QuanLyMuaBan/CongNoBanHang/LuuThanhToan`, data),

}
export default CongNoBanHangApi;